<section class="bleed-surface-100 bleed-bg pt-12">
    <h2 class="text-3xl font-medium mb-6">
      <ng-content>
        Apply in minutes<br />
        <span class="text-orange-gradient">
          We’ll handle the rest.
        </span>
      </ng-content>
    </h2>

  <ul class="flex flex-col gap-6 mb-10">
    <li>
      <app-try-reason text="Create your profile once"/>
    </li>
    <li>
      <app-try-reason text="We automatically apply to eligible lotteries"/>
    </li>
    <li>
      <app-try-reason text="Get notified if you’re selected"/>
    </li>
  </ul>

  <div class="flex flex-row justify-center mb-12">
    <homey-signup-button [wide]="true" [defaultSignupRoute]="defaultSignupRoute()"/>
  </div>

  <p-divider></p-divider>
</section>

<footer homeyFooter [includeTopPadding]="false" [showLogin]="showLogin()"></footer>
